import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el pack después de comprar?',
    a: 'Inmediatamente después de tu pago recibirás acceso a todos los archivos PDF. Puedes descargarlos y usarlos desde tu celular, tablet o computadora.'
  }, {
    q: '¿El pack reemplaza la consulta con un veterinario?',
    a: 'No. Este pack es educativo e informativo. Si tu perro tiene enfermedades, alergias, sobrepeso o necesidades especiales, siempre consulta con un veterinario antes de cambiar su alimentación.'
  }, {
    q: '¿Para qué razas o tamaños de perros sirve?',
    a: 'Las recetas y herramientas son orientativas y sirven como punto de partida para cualquier raza o tamaño. Las porciones exactas dependen del peso, edad y condición de cada perro.'
  }, {
    q: '¿Puedo imprimir los bonos?',
    a: 'Sí. Todos los bonos fueron diseñados para poder imprimirse y usarse en papel si lo prefieres.'
  }, {
    q: '¿Puedo compartir el pack con otras personas?',
    a: 'El pack es para uso personal. No está permitido compartirlo ni distribuirlo.'
  }, {
    q: '¿Qué pasa si tengo dudas después de comprar?',
    a: 'Puedes escribirnos y con gusto te ayudamos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-white" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-10 text-center" data-id="element-47">
          Preguntas frecuentes:
        </h2>

        <div className="space-y-4" data-id="element-48">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-2xl overflow-hidden" data-id="element-49">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between bg-white hover:bg-gray-50 transition-colors" data-id="element-50">
                <span className="font-bold text-brand-navy pr-4" data-id="element-51">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand-orange transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-52" />
              </button>
              <AnimatePresence data-id="element-53">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-54">
                    <div className="px-6 pb-5 text-gray-600 border-t border-gray-100 pt-4 bg-gray-50/50" data-id="element-55">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}